import { render, staticRenderFns } from "./MemberLeft.vue?vue&type=template&id=9a908bc0&scoped=true"
import script from "./MemberLeft.vue?vue&type=script&lang=js"
export * from "./MemberLeft.vue?vue&type=script&lang=js"
import style0 from "./MemberLeft.vue?vue&type=style&index=0&id=9a908bc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a908bc0",
  null
  
)

export default component.exports